import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import CreatableSelect from "react-select/creatable";
import {
  Row,
  Col,
  Form,
  InputGroup,
  Button,
  ButtonGroup
} from 'react-bootstrap'
import Logo from '../images/ScopeHaiLogo-two-color.png'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { CiCircleMinus } from 'react-icons/ci'
import {
  GetCandidateByID,
  fetchAllJobRoles,
  getJobRoleByDomain
} from '../../features/constants/apis'
import {
  submitFormStep2,
  domainJobrolesStep3,
  updateRegistrationStep
} from '../../features/auth/authSlice'
import axios from '../../AxiosConfig'
import { Navigate } from 'react-router'
import { useNavigate } from 'react-router-dom'
import jwt_decode from 'jwt-decode'
import SideValiDidi from './SideValiDidi'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'
import UpdateSkills from './Modals/Forms/UpdateSkills'

const Opportunity = ({
  ID,
  opportunityAuthToken,
  onSendData,
  submitFormStep3,
  domainJobrolesStep3,
  updateRegistrationStep,
  skillsArr
}) => {
  console.log('is function imported: ', submitFormStep3, opportunityAuthToken)
  console.log('is ID imported: ', ID)

  const [jobRoles, setJobRoles] = useState([])
  const [newJobRole, setNewJobRole] = useState([])
  const [candidateData, setCandidateData] = useState([])
  const [domainJobRoles, setDomainJobRoles] = useState([])
  const [demoData, setDemoData] = useState([])
  const [show, setShow] = useState(false)
  const [opportunityTitle, setOpportunityTitle] = useState(null)
  const [opportunityDomainName, setOpportunityDomainName] = useState(null)
  const [renderOpportunity, setRenderOpportunity] = useState(0)
  const [selectDomain, setSelectDomain] = useState(null);
  const [selectedJobRole, setSelectedJobRole] = useState(null);
  const [allJobRoles, setAlljobRoles] = useState([])

  useEffect(() => {
    const fetchCandidateByID = async () => {
      console.log(
        'OPPORTINITY CANDIDATE API CALLED WITH TOKEN',
        opportunityAuthToken
      )
      console.log(ID, opportunityAuthToken)
      let data
      if (opportunityAuthToken && ID) {
        setTimeout(async () => {
          data = await GetCandidateByID(ID, opportunityAuthToken)
        }, 100)
      }
      console.log(data)
      setCandidateData(data?.data)
    }
    fetchCandidateByID()
  }, [ID, opportunityAuthToken])

  useEffect(() => {
    console.log("user-getJobrolesByDomain running");

    const fetchJobRoles = async () => {
      const data = await fetchAllJobRoles(opportunityAuthToken)
      console.log("all jobroles data: ", data.data);
      setAlljobRoles(data.data)
      const jobRoleTitleArry = data?.data.map(title => title.Title)
      // console.log("jobRoleTitleArry: ", jobRoleTitleArry);
      setNewJobRole(jobRoleTitleArry)

      const response = await getJobRoleByDomain(ID, opportunityAuthToken)
      console.log(response)
      setDemoData(response?.Data?.filterdJobRoles)
      setJobRoles(response?.Data?.filterdJobRoles)
      // console.log(data.data)
    }
    fetchJobRoles()
  }, [opportunityAuthToken])
  // console.log('demo Data :', demoData)
  console.log('new jobroles:', newJobRole)

  useEffect(() => {
    console.log('CANDIDATE DATA', candidateData)
    console.log('OPPORTINITY USEFFECT', opportunityAuthToken)
    console.log('JOB ROLES', jobRoles)
    console.log(
      jobRoles.filter(
        jobRoles => jobRoles.ID == candidateData?.CareerProfile?.domain
      )
    )
    const DomainNameArr = jobRoles.filter(
      jobRoles => jobRoles.ID == candidateData?.CareerProfile?.domain
    )
    console.log(DomainNameArr[0]?.Domain)
    const DomainName = DomainNameArr[0]?.Domain
    console.log(jobRoles)
    const jobRolesArr = jobRoles.filter(
      jobRoles => jobRoles.Domain == DomainName
    )
    console.log(jobRolesArr)
    setDomainJobRoles(jobRolesArr.slice(0, 20))
  }, [candidateData, jobRoles, opportunityAuthToken])

  const handleRemoveJobRole = ID => {
    console.log('REMOVE OPPORTUNITY', ID, domainJobRoles, demoData)
    let tempNewJobRoleArr = []
    // tempNewJobRoleArr = domainJobRoles.filter(item => item.ID !== ID)
    tempNewJobRoleArr = demoData.filter(item => item.ID !== ID)
    console.log(tempNewJobRoleArr)
    setDomainJobRoles(tempNewJobRoleArr)
    setDemoData(tempNewJobRoleArr)
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  const submitJobRoles = () => { }
  console.log('data to insert into the backend:', domainJobRoles)

  const navigate = useNavigate() // Initialize useNavigate hook

  const handleSubmit = async e => {
    e.preventDefault()

    const newStep2RegData = {
      // selectedJobRoles: domainJobRoles,
      selectedJobRoles: demoData,
      stepNo: '3',
      completeProfileStep: ID
    }
    const one = await submitFormStep3(newStep2RegData)
    console.log(one)
    if (one) {
      console.log('Submitting data from child:', newStep2RegData)
      console.log('onSendData', onSendData)
    }

    // Send data to the parent
    // if (onSendData) {
    //     onSendData(newStep2RegData);
    // }
  }

  function handleGoBack() {
    const updateStep = {
      stepNo: 2,
      completeProfileStep: ID
    }
    updateRegistrationStep(updateStep)
  }

  console.log('domainJobRoles:', domainJobRoles)

  const handleAddNewOpportunity = async e => {
    e.preventDefault()
    console.log("selected Jobrole: ", selectedJobRole);
    console.log("jobRoles: ", jobRoles);

    const getJobRoleData = allJobRoles.filter((title) => title.Title == selectedJobRole)
    console.log("get job role data: ", getJobRoleData);

    // let tempNewArr = JSON.parse(JSON.stringify(jobRoles))
    let tempNewArr = [...demoData]
    console.log(tempNewArr)
    const defaultObj = {
      ID: '',
      Title: getJobRoleData[0]?.Title,
      // Title: selectDomain,
      ProfessionalSkills: getJobRoleData ? getJobRoleData[0]?.ProfessionalSkills : [],
      GeneralSkills: getJobRoleData ? getJobRoleData[0]?.GeneralSkills : [],
      // Domain: opportunityDomainName,
      Domain: selectDomain,
      CreatedBy: 2,
      AppVisibility: true,
      SuggestProSkills: null,
      SuggestGenSkills: null,
      Subdomain: null
    }
    console.log(tempNewArr, defaultObj)
    const data1 = await axios.post('/create-jobrole', defaultObj)
    console.log(data1)
    if (data1.data.message == 'Success') {
      console.log(tempNewArr)
      const newObj = { ...defaultObj, ID: data1.data.data.insertedId } // create new object with ID
      const updatedArray = [newObj, ...tempNewArr] // unshift safely
      console.log(updatedArray)

      setShow(false)
      setDemoData(updatedArray)
      setDomainJobRoles(updatedArray)
    }
  }

  let uniqueDomain
  useEffect(() => {
    uniqueDomain = Array.from(
      new Set(
        jobRoles.filter(role => role.AppVisibility).map(role => role.Domain)
      )
    ).map(domain =>
      jobRoles.find(role => role.Domain === domain && role.AppVisibility)
    )
    console.log(uniqueDomain)
    if (uniqueDomain && uniqueDomain.length > 0) {
      setSelectDomain(uniqueDomain[0].Domain)
    }
  }, [jobRoles])
  
//     setSelectDomain(uniqueDomain[0]?.Domain)
//   }, [])

  return (
    <section>
      <div style={{ height: '100vh' }}>
        <div className="h-100">
          <Row className="h-100 w-100">
            <Col md={8} sm={12} className="opp-col-div h-100">
              <div>
                <img src={Logo} style={{ height: '2.5rem' }}></img>
              </div>
              <div
                className="d-flex gap-2 ms-1 position-relative"
                style={{ marginTop: '14px' }}
              >
                <div
                  style={{
                    width: '100px',
                    height: '8px',
                    backgroundColor: '#E5E5E5',
                    borderRadius: '5px'
                  }}
                ></div>
                <div
                  style={{
                    width: '100px',
                    height: '8px',
                    backgroundColor: '#E5E5E5',
                    borderRadius: '5px'
                  }}
                ></div>
                <div
                  style={{
                    width: '100px',
                    height: '8px',
                    backgroundColor: '#E5E5E5',
                    borderRadius: '5px'
                  }}
                ></div>
                <div
                  style={{
                    width: '100px',
                    height: '8px',
                    backgroundColor: '#E5E5E5',
                    borderRadius: '5px'
                  }}
                ></div>
                <div
                  style={{
                    width: '100px',
                    height: '8px',
                    backgroundColor: '#E5E5E5',
                    borderRadius: '5px'
                  }}
                ></div>
                <div
                  style={{
                    width: '100px',
                    height: '8px',
                    backgroundColor: '#358D77',
                    borderRadius: '5px'
                  }}
                ></div>
              </div>
              <span class="ms-1" style={{ fontSize: '14px' }}>
                6 of 6
              </span>

              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <h2 className="mb-0 ms-2" style={{ marginTop: '10px' }}>
                    Opportunities
                  </h2>

                  {/* add opportunites modal start */}
                  <div>
                    <Modal
                      show={show}
                      backdrop="static"
                      centered
                      onHide={() => {
                        setShow(false)
                      }}
                    >
                      <Form
                        onSubmit={e => {
                          handleAddNewOpportunity(e)
                        }}
                      >
                        <Modal.Header closeLabel="close">
                          <Modal.Title>Add New Opportunities</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div>
                            <Form.Group
                              className="mb-3"
                              controlId="jobRoleName"
                            >
                              <Form.Label>Select prefered jobrole</Form.Label>
                              <Select
                                options={newJobRole?.map((title) => ({ label: title, value: title }))}
                                onChange={(selectedOption) => setSelectedJobRole(selectedOption?.value)}
                                value={{ label: selectedJobRole, value: selectedJobRole }}
                                placeholder="Select..."
                                isSearchable
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    height: '2.5rem',
                                    borderRadius: '5px',
                                    border: '1px solid #E5E5E5',
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 5, // Ensure the dropdown is above other UI elements
                                  }),
                                }}
                              />

                            </Form.Group>
                            <Form.Group className="boxed mb-2">
                              <Form.Label htmlFor="xpLevel1">
                                Domains of Interest
                                {/* <span style={{ color: 'red' }}>*</span> */}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Job Role"
                                value={selectDomain}
                                disabled
                              />
                              <InputGroup className="boxed position-relative">

                              </InputGroup>
                            </Form.Group>
                            {/* <UpdateSkills /> */}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="outline-primary"
                            onClick={() => setShow(false)}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            variant="primary"
                          // onClick={() => handelAddOpportunites(userId, comment, hrAttended)}
                          >
                            Add
                          </Button>
                        </Modal.Footer>
                      </Form>
                    </Modal>
                  </div>
                  {/* add opportunites modal end */}
                </div>
                <div>

                  <div className='d-flex mb-3'>
                    <lable
                      className="ms-2 mt-1"
                      style={{ color: '#737373' }}
                    >
                      Add suitable jobroles for you
                    </lable>

                    <button
                      onClick={() => setShow(true)}
                      className="ms-2 mt-1 btn btn-primary btn-sm position absolute"
                    >
                      Add Jobrole
                    </button>
                  </div>

                  <lable
                    className="ms-2"
                    style={{ color: '#737373', text: 'start' }}
                  >
                    Review job profiles tailored just for you. Remove the job
                    profiles that don't fit you.
                  </lable>

                </div>
              </div>

              <div
                class="ms-2 mt-2"
                style={{ height: '55vh', overflow: 'scroll' }}
              >
                <div class="row w-100">
                  {/* {jobRoles?.slice(0, 20).map((v, k) => { */}
                  {demoData?.slice(0, 20).map((v, k) => {
                    return (
                      <div class="col-12 col-md-4 mb-2" key={k}>
                        <div class="card border h-100">
                          <div class="card-body p-1 h-100 d-flex flex-column">
                            <h3 class="mb-0">{v.Title}</h3>
                            <h6
                              class="mb-0 text-secondary"
                              style={{ marginTop: '3px' }}
                            >
                              Interprting complex datasets for stratigic
                              decisions.
                            </h6>
                            <div class="mt-1 mb-1">
                              {v?.ProfessionalSkills?.map((v1, k1) => {
                                return (
                                  <span
                                    class="badge border text-black"
                                    style={{ marginRight: '3px' }}
                                  >
                                    {v1}
                                  </span>
                                )
                              })}
                            </div>

                            <button
                              class="btn btn-outline-danger ps-1 pe-1"
                              style={{
                                height: '34px',
                                marginTop: 'auto',
                                display: 'block',
                                width: 'fit-content'
                              }}
                              onClick={() => {
                                handleRemoveJobRole(v.ID)
                              }}
                            >
                              <span class="text-danger">
                                Remove <CiCircleMinus size={15} />{' '}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ms-2 mt-1 d-flex justify-content-between">
                  <div>
                    <button
                      type="button"
                      onClick={handleGoBack}
                      className="btn btn-outline-primary"
                      style={{ height: '48px', fontSize: '20px' }}
                    >
                      <ArrowLeft
                        className="me-1"
                        style={{ height: '15px', width: '15px' }}
                      />{' '}
                      Back <span className="ms-1"></span>
                    </button>
                  </div>
                  <div>
                    <Button
                      type="submit"
                      className="btn mb-2"
                      style={{
                        backgroundColor: '#358D77',
                        color: 'white',
                        height: '48px',
                        fontSize: '20px'
                      }}
                    >
                      Finish
                      <span className="ms-1">
                        <ArrowRight style={{ height: '15px', width: '15px' }} />
                      </span>
                    </Button>
                  </div>
                </div>
              </form>
            </Col>
            <Col md={4} sm={12} className="new-ui-otp-col-2">
              <SideValiDidi />
            </Col>
          </Row>
        </div>
      </div>
    </section>
  )
}

const mapStateToProps = ({ auth, data }) => {
  const { ID, opportunityAuthToken } = auth
  const { skillsArr } = data
  return {
    ID,
    opportunityAuthToken,
    skillsArr
  }
}

const mapDispatchToProps = {
  domainJobrolesStep3,
  updateRegistrationStep
}

export default connect(mapStateToProps, mapDispatchToProps)(Opportunity)
